(function () {
  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: Number(variantId), quantity }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Failed to add to cart");
      return res.json();
    });
  }

  function initChemicalSection(section) {
    if (!section || section.dataset.chemicalReady === "true") return;
    if (typeof Swiper === "undefined") return;

    section.dataset.chemicalReady = "true";

    const tabs = section.querySelectorAll("[data-chemical-tab]");
    const panels = section.querySelectorAll("[data-chemical-panel]");
    const dropdown = section.querySelector("[data-chemical-dropdown]");
    const dropdownBtn = section.querySelector("[data-chemical-dropdown-btn]");
    const dropdownLabel = section.querySelector("[data-chemical-dropdown-label]");
    const dropdownOptions = section.querySelectorAll("[data-chemical-option]");
    const headerPrev = section.querySelectorAll("[data-chemical-prev]");
    const headerNext = section.querySelectorAll("[data-chemical-next]");
    const swipers = {};
    let activeId = panels[0] ? panels[0].getAttribute("data-chemical-panel") : null;

    function getActiveSwiper() {
      return activeId ? swipers[activeId] || null : null;
    }

    function updateNavState(swiper) {
      if (!swiper) return;
      const isBeginning = swiper.isBeginning;
      const isEnd = swiper.isEnd;

      headerPrev.forEach(function (btn) {
        btn.disabled = isBeginning;
        btn.classList.toggle("swiper-button-disabled", isBeginning);
      });

      headerNext.forEach(function (btn) {
        btn.disabled = isEnd;
        btn.classList.toggle("swiper-button-disabled", isEnd);
      });
    }

    function initPanelSwiper(panel) {
      const id = panel.getAttribute("data-chemical-panel");
      const swiperEl = panel.querySelector("[data-chemical-swiper]");
      const progressEl = panel.querySelector("[data-chemical-progress]");
      if (!id || !swiperEl || swipers[id]) return;

      swipers[id] = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: progressEl,
          type: "progressbar",
        },
        breakpoints: {
          769: {
            spaceBetween: 14,
          },
        },
        on: {
          init: function () {
            if (id === activeId) updateNavState(this);
          },
          slideChange: function () {
            if (id === activeId) updateNavState(this);
          },
          reachBeginning: function () {
            if (id === activeId) updateNavState(this);
          },
          reachEnd: function () {
            if (id === activeId) updateNavState(this);
          },
          fromEdge: function () {
            if (id === activeId) updateNavState(this);
          },
        },
      });
    }

    function setActivePanel(target) {
      activeId = target;

      tabs.forEach(function (tab) {
        const isActive = tab.getAttribute("data-chemical-tab") === target;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      dropdownOptions.forEach(function (option) {
        const isActive = option.getAttribute("data-chemical-option") === target;
        option.classList.toggle("is-active", isActive);
        if (isActive && dropdownLabel) {
          dropdownLabel.textContent = option.textContent.trim();
        }
      });

      panels.forEach(function (panel) {
        const id = panel.getAttribute("data-chemical-panel");
        const isActive = id === target;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;

        if (isActive) {
          initPanelSwiper(panel);
          if (swipers[id]) {
            swipers[id].update();
            updateNavState(swipers[id]);
          }
        }
      });

      if (dropdown) {
        dropdown.classList.remove("is-open");
        if (dropdownBtn) dropdownBtn.setAttribute("aria-expanded", "false");
      }
    }

    panels.forEach(function (panel) {
      if (!panel.hidden) initPanelSwiper(panel);
    });

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        setActivePanel(tab.getAttribute("data-chemical-tab"));
      });
    });

    if (dropdownBtn && dropdown) {
      dropdownBtn.addEventListener("click", function () {
        const isOpen = dropdown.classList.toggle("is-open");
        dropdownBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    }

    dropdownOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        setActivePanel(option.getAttribute("data-chemical-option"));
      });
    });

    document.addEventListener("click", function (event) {
      if (!dropdown || !dropdown.classList.contains("is-open")) return;
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove("is-open");
        if (dropdownBtn) dropdownBtn.setAttribute("aria-expanded", "false");
      }
    });

    headerPrev.forEach(function (btn) {
      btn.addEventListener("click", function () {
        const swiper = getActiveSwiper();
        if (swiper) swiper.slidePrev();
      });
    });

    headerNext.forEach(function (btn) {
      btn.addEventListener("click", function () {
        const swiper = getActiveSwiper();
        if (swiper) swiper.slideNext();
      });
    });

    section.querySelectorAll("[data-chemical-add]").forEach(function (btn) {
      btn.addEventListener("click", async function () {
        const variantId = Number(btn.getAttribute("data-variant-id"));
        if (!variantId || btn.disabled) return;

        const originalHtml = btn.innerHTML;
        try {
          btn.disabled = true;
          btn.textContent = "Adding...";
          await addToCart(variantId, 1);
          document.dispatchEvent(
            new CustomEvent("cart:refresh", { detail: { openDrawer: true } })
          );
        } catch (error) {
          console.error("Chemical by need add to cart error:", error);
        } finally {
          btn.disabled = false;
          btn.innerHTML = originalHtml;
        }
      });
    });

    updateNavState(getActiveSwiper());
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-chemical]").forEach(initChemicalSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    initAll(event.target);
  });
})();
